import React from 'react'

type Props = {
    className?  : string

    type        : 'default' | 'ui5'

    value       : number
    minValue    : number
    maxValue    : number
    step        : number
    disabled    : boolean

    onChange    : {(value: number): void}
}

type State = {
    value: number
}

export default class Stepper extends React.Component<Props, State> {

    static defaultProps = {
        type        : 'default',
        value       : 0,
        minValue    : null,
        maxValue    : null,
        step        : 1,
        disabled    : false
    }

    constructor(props: Props) {
        super(props);

        this.state = {
            value: this.props.value
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: Props) {
        if (nextProps.value !== this.state.value) this.setValue(nextProps.value)
    }

    setValue = (value: number) => {
        this.setState({value:value})
    }

    getValue = () => {
        return this.state.value
    }

    onClickDec = () => {
        this.handleUserChangeValue(this.state.value - this.props.step)
    }
    onClickInc = () => {
        this.handleUserChangeValue(this.state.value + this.props.step)
    }

    handleUserChangeValue = (value: number) => {
        if (this.props.disabled) return;

        let newValue = value;
        if (!_.isNil(this.props.minValue) && newValue < this.props.minValue) newValue = this.props.minValue;
        else if (!_.isNil(this.props.maxValue) && newValue > this.props.maxValue) newValue = this.props.maxValue;

        this.setState({value:newValue}, ()=>{
            if (this.props.onChange) this.props.onChange(newValue);
        })
    }

    render() {
        const classes = Classes(this.props.className, {
            'stepper'       : this.props.type === 'default',
            'ui5-stepper'   : this.props.type === 'ui5',
            'is-disabled'   : this.props.disabled
        })

        return (
            <div className={classes}>
                <div className="step-dec" onClick={this.onClickDec}/>
                <div className="step-value">{this.state.value}</div>
                <div className="step-inc" onClick={this.onClickInc}/>
            </div>
        )
    }
}
